import { Fragment, h } from 'preact'; /** @jsx h */

const NotFound404 = () => {
    return (
        <>
            <h1 className="wp-block-snla-heading wp-ta-center" data-width="false">
                HTTP 404 - Siden finnes ikke
            </h1>
            <p className="wp-block-snla-paragraph wp-ta-center is-style-big">
                Du har kommet til en side som dessverre ikke finnes. Hvis du skrev inn adressen selv
                kan det hende det har sneket seg med en skrivefeil. Hvis du klikket på en lenke er
                denne ødelagt. Hvis du har tid så blir webredaksjonen veldig glad for tips om dette
                på{' '}
                <a href="mailto:webredaksjon@norskluftambulanse.no">
                    webredaksjon@norskluftambulanse.no
                </a>
                . For å finne det du lette etter kan du prøve å gå til <a href="/">forsiden</a>.
            </p>
            <div className="wp-block-snla-luftig-space"></div>
        </>
    );
};

export default NotFound404;
